const TECHNICAL_PATTERNS = [
  /^network error$/i,
  /^err_network$/i,
  /timeout/i,
  /request failed/i,
  /internal server error/i,
  /^500$/,
  /^401$/,
  /^403$/,
  /^404$/,
  /axios/i,
  /cors/i,
  /econnrefused/i,
  /failed to fetch/i,
];

const KNOWN_API_MESSAGES = {
  "Parâmetro company é obrigatório.":
    "Este link de acesso está incompleto. Use o endereço completo enviado pela empresa.",
  "Workspace não encontrado.":
    "Não encontramos o portal da empresa informada. Confira o link recebido ou fale com o suporte.",
  "Workspace (company) é obrigatório.":
    "Use o link de acesso enviado pela empresa para entrar no portal.",
  "Erro ao carregar portal.":
    "Não foi possível carregar o portal agora. Atualize a página ou tente novamente em instantes.",
  "Erro no login.":
    "Não foi possível entrar agora. Aguarde um momento e tente de novo.",
  "Erro ao processar solicitação.":
    "Não foi possível processar seu pedido agora. Tente novamente em alguns minutos.",
  "Erro ao validar token.":
    "Não foi possível validar o link de senha. Solicite um novo e-mail de recuperação.",
  "Erro ao definir senha.":
    "Não foi possível salvar sua senha agora. Tente novamente em instantes.",
  "Não autenticado.":
    "Sua sessão expirou. Faça login novamente para continuar.",
  "Erro ao carregar perfil.":
    "Não foi possível carregar seus dados. Faça login novamente.",
  "Erro ao listar chamados.":
    "Não foi possível carregar suas solicitações. Atualize a página ou tente de novo.",
  "Erro ao carregar chamado.":
    "Não foi possível abrir esta solicitação. Atualize a página ou tente de novo.",
  "Erro ao carregar mensagens.":
    "Não foi possível carregar as mensagens. Atualize a página ou tente de novo.",
  "Chamado não encontrado.":
    "Esta solicitação não foi encontrada ou não está mais disponível para você.",
  "Erro ao abrir chamado.":
    "Não foi possível abrir sua solicitação agora. Tente novamente em instantes.",
  "Erro ao enviar mensagem.":
    "Sua mensagem não foi enviada. Verifique sua conexão e tente novamente.",
  "Erro ao reabrir solicitação.":
    "Não foi possível reabrir a solicitação agora. Tente novamente em instantes.",
  "Erro ao preparar upload.":
    "Não foi possível enviar o arquivo. Tente um arquivo menor ou outro formato.",
  "Erro ao carregar tipos.":
    "Não foi possível carregar os tipos de solicitação. Você ainda pode abrir uma solicitação geral.",
  "Token ausente.":
    "O link de senha está incompleto. Abra novamente o e-mail e clique no botão de redefinição.",
  "Parâmetros ausentes.":
    "Preencha todos os campos para definir sua senha.",
  "Token inválido.":
    "Este link de senha não é válido. Solicite um novo e-mail em “Esqueci minha senha”.",
  "Token já utilizado.":
    "Este link de senha já foi usado. Se precisar, solicite um novo e-mail de recuperação.",
  "Token expirado.":
    "Este link de senha expirou. Solicite um novo e-mail em “Esqueci minha senha”.",
  "Não foi possível determinar o tipo do lead. Verifique tipos permitidos e defaults.":
    "Não foi possível classificar sua solicitação automaticamente. Tente novamente ou fale com o suporte da empresa.",
  "Seu usuário não tem permissão para o tipo de atendimento necessário para criar esta solicitação.":
    "Não foi possível abrir a solicitação com o tipo disponível para você. Fale com o suporte da empresa para ajustar o acesso.",
  "Não foi possível definir o tipo da solicitação: não há tipo raiz ativo ou padrão no workspace.":
    "Não foi possível classificar sua solicitação automaticamente. Tente novamente ou fale com o suporte da empresa.",
  "Não foi possível localizar ou cadastrar o cliente para este atendimento.":
    "Não foi possível identificar seu cadastro para abrir a solicitação. Entre em contato com o suporte da empresa.",
  "E-mail ou senha inválidos.":
    "E-mail ou senha incorretos. Confira os dados e tente novamente. Se esqueceu a senha, use “Esqueci minha senha”.",
  "Acesso ao portal não liberado. Entre em contato com o suporte.":
    "Seu cadastro ainda não tem permissão para usar o portal. Entre em contato com a empresa para solicitar o acesso.",
  "Senha ainda não cadastrada. Verifique seu e-mail para o convite.":
    "Você ainda não criou sua senha de acesso. Abra o e-mail de convite que enviamos e conclua o cadastro.",
  "Acesso revogado.":
    "Seu acesso ao portal foi desativado. Entre em contato com a empresa se precisar de ajuda.",
  "Canal Xpro Cliente não configurado. Peça ao suporte para habilitar o canal no projeto.":
    "O portal ainda não está disponível para sua empresa. Peça ao suporte da empresa para habilitar o acesso.",
  "O portal ainda não está disponível para sua empresa.":
    "O portal ainda não está disponível para sua empresa. Peça ao suporte da empresa para habilitar o acesso.",
  "Esta solicitação está encerrada. Reabra o mesmo chamado ou abra uma nova solicitação.":
    "Esta solicitação está encerrada e não aceita novas mensagens. Reabra a solicitação ou abra uma nova se o problema continuar.",
  "Você já possui uma solicitação em andamento para este assunto.":
    "Você já tem uma solicitação em andamento para este assunto. Acompanhe a solicitação existente ou aguarde o atendimento.",
};

const CONTEXT_FALLBACKS = {
  login: {
    network:
      "Não conseguimos conectar ao portal. Verifique sua internet e tente de novo. Se o problema continuar, entre em contato com o suporte da empresa.",
    timeout:
      "A conexão demorou mais que o esperado. Verifique sua internet e tente entrar novamente.",
    default:
      "Não foi possível entrar. Confira e-mail e senha e tente de novo. Se o erro continuar, use “Esqueci minha senha” ou fale com o suporte.",
    401:
      "E-mail ou senha incorretos. Confira os dados e tente novamente. Se esqueceu a senha, use “Esqueci minha senha”.",
    403:
      "Seu acesso ao portal ainda não está liberado. Entre em contato com a empresa para solicitar o acesso.",
  },
  forgotPassword: {
    network:
      "Não conseguimos enviar o e-mail agora. Verifique sua internet e tente novamente em alguns minutos.",
    default:
      "Não foi possível enviar o e-mail de recuperação. Tente novamente em instantes.",
  },
  password: {
    network:
      "Não conseguimos salvar sua senha. Verifique sua internet e tente novamente.",
    default:
      "Não foi possível definir sua senha. Tente novamente ou solicite um novo link por e-mail.",
  },
  ticketList: {
    network:
      "Não conseguimos carregar suas solicitações. Verifique sua internet e toque em “Tentar de novo”.",
    default:
      "Não foi possível carregar suas solicitações. Atualize a página ou tente novamente.",
  },
  ticketDetail: {
    network:
      "Não conseguimos carregar esta solicitação. Verifique sua internet e atualize a página.",
    default:
      "Não foi possível carregar esta solicitação. Atualize a página ou tente de novo.",
  },
  sendMessage: {
    network:
      "Sua mensagem não foi enviada. Verifique sua internet e tente enviar novamente.",
    default:
      "Não foi possível enviar sua mensagem. Tente novamente em instantes.",
  },
  reopen: {
    network:
      "Não conseguimos reabrir a solicitação. Verifique sua internet e tente de novo.",
    default:
      "Não foi possível reabrir a solicitação. Tente novamente ou abra uma nova solicitação.",
  },
  newTicket: {
    network:
      "Não conseguimos abrir sua solicitação. Verifique sua internet e tente enviar novamente.",
    default:
      "Não foi possível abrir sua solicitação. Revise o texto e tente de novo em instantes.",
  },
  bootstrap: {
    default:
      "Não foi possível carregar o portal agora. Atualize a página ou tente novamente em instantes.",
    network:
      "Não conseguimos conectar ao portal. Verifique sua internet e tente novamente.",
  },
  general: {
    network:
      "Não conseguimos conectar ao portal. Verifique sua internet e tente novamente.",
    timeout:
      "A conexão demorou mais que o esperado. Verifique sua internet e tente novamente.",
    default:
      "Algo deu errado. Tente novamente em instantes. Se o problema continuar, fale com o suporte da empresa.",
    401: "Sua sessão expirou. Faça login novamente para continuar.",
    403: "Você não tem permissão para esta ação. Fale com o suporte da empresa se precisar de ajuda.",
    404: "Não encontramos o que você procurou. Volte e tente novamente.",
    500: "O portal está temporariamente indisponível. Aguarde alguns minutos e tente de novo.",
  },
};

function isTechnicalMessage(message) {
  const text = String(message || "").trim();
  if (!text) return true;
  return TECHNICAL_PATTERNS.some((pattern) => pattern.test(text));
}

function isNetworkError(err) {
  if (!err) return false;
  if (!err.response) return true;
  const code = String(err.code || "").toUpperCase();
  const message = String(err.message || "").toLowerCase();
  return (
    code === "ERR_NETWORK" ||
    code === "ECONNABORTED" ||
    message.includes("network error") ||
    message.includes("timeout")
  );
}

function isTimeoutError(err) {
  const code = String(err?.code || "").toUpperCase();
  const message = String(err?.message || "").toLowerCase();
  return code === "ECONNABORTED" || message.includes("timeout");
}

function formatApiPayload(data) {
  if (!data || typeof data !== "object") return null;

  let message = data.message;
  if (message && KNOWN_API_MESSAGES[message]) {
    message = KNOWN_API_MESSAGES[message];
  }

  if (!message || isTechnicalMessage(message)) return null;

  const action = data.userAction ? String(data.userAction).trim() : "";
  if (action && !message.includes(action)) {
    return `${message} ${action}`;
  }
  return message;
}

export function getClientPortalErrorMessage(err, options = {}) {
  const context = options.context || "general";
  const fallbacks = CONTEXT_FALLBACKS[context] || CONTEXT_FALLBACKS.general;

  if (err?.isPortalClientError && err?.message && !isTechnicalMessage(err.message)) {
    return err.message;
  }

  const apiMessage = formatApiPayload(err?.response?.data);
  if (apiMessage) return apiMessage;

  if (isNetworkError(err)) {
    if (isTimeoutError(err) && fallbacks.timeout) return fallbacks.timeout;
    return fallbacks.network || CONTEXT_FALLBACKS.general.network;
  }

  const status = err?.response?.status;
  if (status && fallbacks[status]) return fallbacks[status];
  if (status && CONTEXT_FALLBACKS.general[status]) return CONTEXT_FALLBACKS.general[status];

  if (options.fallback) return options.fallback;
  return fallbacks.default || CONTEXT_FALLBACKS.general.default;
}

export function isPortalUnavailableError(err) {
  const code = String(err?.response?.data?.code || "").toUpperCase();
  if (code === "CHANNEL_NOT_CONFIGURED") return true;

  const message = String(err?.response?.data?.message || "").toLowerCase();
  return (
    err?.response?.status === 403 &&
    (message.includes("não está disponível") || message.includes("habilitar o acesso"))
  );
}
